<template>
  <div />
</template>

<script>
export default {
  name: "DrivingControls",
  data() {
    return {
      accelerating: 0,
      direction: 1,
      flipped: false,
      minimap: 0,
      timer: null
    };
  },
  mounted() {
    window.addEventListener("keydown", this.keydown);
    window.addEventListener("keyup", this.keyup);

    this.animate();
  },
  beforeDestroy() {
    cancelAnimationFrame(this.timer);
    window.removeEventListener("keydown", this.keydown);
    window.removeEventListener("keyup", this.keyup);
  },
  methods: {
    keydown(e) {
      if (e.code === "ArrowLeft") {
        this.accelerating = 1;
        this.direction = 1;
      } else if (e.code === "ArrowRight") {
        this.accelerating = -1;
        this.direction = -1;
      }

      if (this.$store.state.geolocation.flipped) {
        this.accelerating *= -1;
        this.direction *= -1;
      }

      if (e.code === "Space" && this.$route.name !== "narrative") {
        this.$store.dispatch("flip");
      }
    },
    keyup(e) {
      if (e.code === "ArrowLeft" || e.code === "ArrowRight") {
        this.accelerating = 0;
      }
    },
    animate(timestamp) {
      this.timer = requestAnimationFrame(this.animate);
      this.$store.commit("accelerate", this.accelerating);
      this.$store.commit("tick", { timestamp });
    }
  }
};
</script>

<style lang="sass" scoped></style>
